import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    pageIndex: '第 {index} 页',
    prev: '上一页',
    next: '下一页',
    detail: '当前是第 {index} 页，共 {total} 页'
  },
  {
    ns: 'carousel'
  }
)
